import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationRunMultiPromptRunnerAsyncArgs,
  BackendRunMultiPromptRunnerAsyncPayload,
} from 'src/types/backend';

const MUTATION = gql`
  mutation RunMultiPromptRunnerAsync(
    $chainId: ID!
    $cloneChain: Boolean
    $csvChainId: ID
    $blocksUpdatedSettings: JSON!
    $removedBlocks: [ID!]
  ) {
    runMultiPromptRunnerAsync(
      chainId: $chainId
      cloneChain: $cloneChain
      csvChainId: $csvChainId
      blocksUpdatedSettings: $blocksUpdatedSettings
      removedBlocks: $removedBlocks
    ) {
      chainId
      csvChainId
    }
  }
`;

type Variables = BackendMutationRunMultiPromptRunnerAsyncArgs;
type Result = BackendRunMultiPromptRunnerAsyncPayload;

export const runMultiPromptRunnerAsync = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
